import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import {
  recentProjectsData,
  otherProjectsData1,
  otherProjectsData2,
} from "../../portfolioData";
import "./index.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const Projects = () => {
  const theme = useSelector((state) => state.theme);
  const textColor = theme === "LIGHT" ? "projects-light" : "projects-dark";
  const projectCardClass =
    theme === "LIGHT" ? "project-card-light" : "project-card-dark";

  const settings = {
    infinite: true,
    dots: false,
    autoplay: true,

    cssEase: "linear",
    pauseOnHover: true,
    pauseOnFocus: true,
    centerPadding: "auto",
    fade: false,
    easing: "linear",
    rows: 1,
    responsive: [
      {
        breakpoint: 3000,
        settings: {
          slidesToShow: 6,
          slidesToScroll: 6,
          speed: 7000,
          autoplaySpeed: 7000,
        },
      },
      {
        breakpoint: 2054,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 5,
          speed: 6000,
          autoplaySpeed: 6000,
        },
      },
      {
        breakpoint: 1701,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
          speed: 5000,
          autoplaySpeed: 5000,
        },
      },
      {
        breakpoint: 1359,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          speed: 4000,
          autoplaySpeed: 4000,
        },
      },
      {
        breakpoint: 839,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          speed: 3000,
          autoplaySpeed: 3000,
        },
      },
      {
        breakpoint: 528,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          speed: 2000,
          autoplaySpeed: 2000,
        },
      },
    ],
  };

  const reverseSetting = { rtl: true, ...settings };

  const recentProjectCard = (project) => {
    const { title, description, iconUrl, imageUrl, projectLink, githubLink } =
      project;

    return (
      <div className={`project-card ${projectCardClass}`}>
        <section className="project-details-container">
          <img src={iconUrl} className="project-card-icon" alt="projectIcon" />
          <h2 className="project-card-title">{title}</h2>
          <p className="project-card-description">{description}</p>
          <section className="project-card-buttons-container">
            <a
              href={projectLink}
              target="blank"
              className="project-link-button"
            >
              Website &#8594;
            </a>
            <a href={githubLink} target="blank" className="github-link-button">
              Github &#8594;
            </a>
          </section>
        </section>
        <img src={imageUrl} className="project-card-image" alt="projectImage" />
      </div>
    );
  };

  const otherProjectCard = (project) => {
    const { title, imageUrl, projectLink, githubLink } = project;

    return (
      <div className={`other-project-card ${projectCardClass}`}>
        <h2 className="other-project-card-title">{title}</h2>
        <img
          src={imageUrl}
          className="other-project-card-image"
          alt="projectImage"
        />
        <section className="other-project-card-buttons-container">
          <a
            href={projectLink}
            target="_main"
            className="other-project-link-button"
          >
            Website &#8594;
          </a>
          <a
            href={githubLink}
            target="_main"
            className="other-github-link-button"
          >
            Github &#8594;
          </a>
        </section>
      </div>
    );
  };

  return (
    <div className={`projects ${textColor}`}>
      <h1 className="projects-title">Projects</h1>
      <p className="projects-caption">Projects and ideas I've worked on.</p>
      <hr
        style={{
          background:
            theme === "LIGHT"
              ? "rgba(0, 0, 0, 0.10)"
              : "rgba(255, 255, 255, 0.10)",
          width: "100vw",
          position: "relative",
          left: "calc((100% - 100vw) / 2)",
        }}
      />
      <ul className="recent-projects-container row">
        {recentProjectsData.map((project) => (
          <li key={project.id} className="col-12">
            {recentProjectCard(project)}
          </li>
        ))}
      </ul>

      <p className="projects-caption mt-5 mb-3">Other Projects</p>

      <div style={{ width: "100%" }}>
        <Slider {...settings}>
          {otherProjectsData1.map((project) => (
            <li key={project.id} className="ps-2 pe-2">
              {otherProjectCard(project)}
            </li>
          ))}
        </Slider>
      </div>
      <div style={{ width: "100%" }}>
        <Slider {...reverseSetting}>
          {otherProjectsData2.map((project) => (
            <li key={project.id} className="ps-2 pe-2">
              {otherProjectCard(project)}
            </li>
          ))}
        </Slider>
      </div>
      <li className="col-12 mt-5" style={{ listStyleType: "none" }}>
        <div className={`project-card ${projectCardClass} p-5 `}>
          <section className="your-project-details-container ">
            <img
              src="https://res.cloudinary.com/ddaimmqrr/image/upload/v1696345104/Portfolio%20App/Stars_qoxqsu.png"
              className="your-project-card-icon"
              alt="projectIcon"
            />
            <h2 className="project-card-title">Your Project Goes Here</h2>
            <p className="project-card-description mb-5">
              Let’s turn your idea into a visual reality
            </p>
            <Link to="/contact">
              <button type="button" className="home-contact-button mt-4">
                <img
                  src="https://res.cloudinary.com/ddaimmqrr/image/upload/v1696177552/Portfolio%20App/Send_t494gs.png"
                  alt="send icon"
                />{" "}
                Get in Touch
              </button>
            </Link>
          </section>
        </div>
      </li>
    </div>
  );
};

export default Projects;
